import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useMemo } from 'react';
import classnames from 'classnames';
import BaseViewer from './Base';
import mergeTheme from '../Themes/mergeTheme';
import baseTheme from '../Themes/Viewer/status.scss';
const StatusViewer = (_param)=>{
    var { theme: themeFromProps, isShortStatus } = _param, props = _object_without_properties(_param, [
        "theme",
        "isShortStatus"
    ]);
    const theme = useMemo(()=>mergeTheme(baseTheme, themeFromProps), [
        themeFromProps
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('da-editor-status', isShortStatus && 'da-editor-status-short')
    }, /*#__PURE__*/ React.createElement(BaseViewer, _object_spread_props(_object_spread({
        theme: theme
    }, props), {
        fixedParagraph: false
    })));
};
StatusViewer.displayName = 'StatusViewer';
export const ShortStatusViewer = (props)=>/*#__PURE__*/ React.createElement(StatusViewer, _object_spread_props(_object_spread({}, props), {
        isShortStatus: true
    }));
ShortStatusViewer.displayName = 'ShortStatusViewer';
export const LongStatusViewer = (props)=>/*#__PURE__*/ React.createElement(StatusViewer, props);
LongStatusViewer.displayName = 'LongStatusViewer';
export default StatusViewer;
